import { render, staticRenderFns } from "./ReturnPolicySection.vue?vue&type=template&id=53240f5c&scoped=true&"
import script from "./ReturnPolicySection.vue?vue&type=script&lang=js&"
export * from "./ReturnPolicySection.vue?vue&type=script&lang=js&"
import style0 from "./ReturnPolicySection.vue?vue&type=style&index=0&id=53240f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53240f5c",
  null
  
)

export default component.exports